import {AIAssetTypeOld} from 'common/src/modules/Assets/Assets.enums';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {AdBuilderAgentToolName} from '../adBuilderAgent.enums';

// Schema for importing asset from brand assets
const inputSchema = z.object({
  creativeAssetType: z
    .enum([AIAssetTypeOld.Image, AIAssetTypeOld.Video])
    .describe('Type of creative asset to import'),
  assetId: z.string().describe('ID of the brand asset to import'),
});

function importAssetFromBrandAssetsTool(_store: CLStore) {
  return tool({
    name: AdBuilderAgentToolName.ImportAssetFromBrandAssets,
    displayName: 'Importing asset from brand assets',
    description:
      'Imports an asset from brand assets to template assets. Currently supports Image assets only.',
    inputSchema,
    execute: async (_params: ToolExecuteParams<typeof inputSchema>) => {
      return {
        content: 'ERROR: Not Implemented Yet',
      };
    },
  });
}

export default importAssetFromBrandAssetsTool;
